type NewMessageNotificationFlags = {
    web?: boolean
    sound?: boolean
}

export type NewMessageAlerts = {
    /** Play the notification sound */
    sound: boolean
    /** Blink the tab title */
    title: boolean
    /** Show the desktop (OS) notification */
    desktop: boolean
}

const NO_ALERTS: NewMessageAlerts = {sound: false, title: false, desktop: false}

/**
 * Which alerts a NEW_MESSAGE socket packet should trigger for the current user. chat-api computes
 * `notification.web` / `notification.sound` per recipient (room notification settings, departmental chat
 * routing): `false` means this user must not be alerted. Packets without the flags keep the legacy behaviour
 * (desktop notification only).
 */
export const getNewMessageAlerts = (
    message: {fromUserId?: number; notification?: NewMessageNotificationFlags | null},
    currentUserId: number
): NewMessageAlerts => {
    if (message.fromUserId === currentUserId) {
        return NO_ALERTS
    }
    const {notification} = message
    if (!notification) {
        return {sound: false, title: false, desktop: true}
    }
    return {
        sound: notification.sound === true,
        title: notification.web === true,
        desktop: notification.web === true
    }
}
